/**
 * AuthNotice — full-width status banner rendered above/below a form.
 *
 * variants: 'info' | 'success' | 'error'. The aria-live region is
 * polite by default so the SR announces it once it appears without
 * interrupting the user mid-type.
 */

import React from 'react';

function AuthNotice({ variant = 'info', children, ...rest }) {
  return (
    <div
      role={variant === 'error' ? 'alert' : 'status'}
      aria-live={variant === 'error' ? 'assertive' : 'polite'}
      className={`auth-notice auth-notice-${variant}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export default AuthNotice;
